import { Typography } from "@circle-react-uikit/Typography";

import { t } from "@/i18n-js/instance";
import { TippyV2 } from "@/react/components/SettingsApp/CompassCompat/Tooltip";

import { IconButton } from "../../IconButton";

interface HeaderUIKitProps {
  onClose?: () => void;
}

export const HeaderUIKit = ({ onClose }: HeaderUIKitProps) => (
  <div className="flex items-center justify-between px-6 pb-2 pt-5">
    <Typography.LabelLg weight="medium">
      {t("header_v3.connect.title")}
    </Typography.LabelLg>
    {onClose && (
      <TippyV2 interactive={false} content={t("header_v3.close")}>
        <IconButton
          name="16-close"
          ariaLabel={t("header_v3.close")}
          onClick={onClose}
          iconClassName="!text-dark !h-5 !w-5"
          className="!p-0"
          dataTestId="connect-panel-close-button"
        />
      </TippyV2>
    )}
  </div>
);
